module.exports = __webpack_public_path__ + "img/check.6069f881.svg";